import { queryKeysBuilder } from '@/api/queries.utils';

const builder = queryKeysBuilder(['alerts']);

export const alertsQueryKeys = {
  all: builder(),
};
